<template>
    <el-form :model="handleItem" ref="handleItemForm">
        <div class="simple-form" v-if="!fiscalHandle">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">处理方式</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="wayValue" :rules="{validator: checkNull, trigger: 'blur'}">
                        <el-select v-model="handleItem.wayValue" placeholder="请选择" @change="clearTheOtherInfo">
                            <el-option v-for="item in assetCheckHandleWayEnumList" :label="item.text" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">处理数量</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="quantity" :rules="{validator: checkQuantity, trigger: 'blur'}">
                        <input class="align-right" type="number" :disabled="batch != null && batch" v-model="handleItem.quantity" :min="1" :max="voucherItem.allowQuantity"/>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center" v-if="handleItem.wayValue == -3">
                <div class="form-label">
                    <label>清除原因</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="clearCause">
                        <el-select v-model="handleItem.clearCause" placeholder="请选择清除原因">
                            <el-option v-for="item in devcClearCauseEnumList" :label="item.text" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <!-- 少调入单、少调出单 -->
            <template v-if="handleItem.wayValue == 2 || handleItem.wayValue == -2">
                <div class="form-group center">
                    <div class="form-label">
                        <label>跨机构调拨</label>
                    </div>
                    <div class="form-value">
                        <el-form-item>
                            <el-radio-group v-model="transComFlag" @change="clearTheOtherInfo">
                                <el-radio :label="true">是</el-radio>
                                <el-radio :label="false">否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="transComFlag">
                    <div class="form-label">
                        <label v-if="handleItem.wayValue == 2">调出机构</label>
                        <label v-if="handleItem.wayValue == -2">调入机构</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="theOtherComName">
                            <el-input class="bottom-line width-1-5x" v-model="handleItem.theOtherComName" :disabled="true"></el-input>
                            <i class="icon iconfont icon-chazhaobiaodanliebiao relation-icon" title="选择机构" @click="showOrgSelectDlg()"></i>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group center" v-if="!transComFlag">
                    <div class="form-label">
                        <label v-if="handleItem.wayValue == 2">调出仓库</label>
                        <label v-if="handleItem.wayValue == -2">调入仓库</label>
                    </div>
                    <div class="form-value width-2x">
                        <el-form-item prop="theOtherWarehouseId">
                            <el-select v-model="handleItem.theOtherWarehouseId" clearable placeholder="请选择仓库" @change="compareIn">
                                <el-option v-for="item in warehouseList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
            </template>
        </div>
        <div class="simple-form" v-if="fiscalHandle">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">处理方式</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="fiscalWayValue" :rules="{validator: checkNull, trigger: 'blur'}">
                        <el-select v-model="handleItem.fiscalWayValue" placeholder="请选择">
                            <el-option v-for="item in assetCheckHandleWayEnumList" :label="item.text" :value="item.value"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">处理数量</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="fiscalQuantity" :rules="{validator: checkFiscalQuantity, trigger: 'blur'}">
                        <input class="align-right" type="number" v-model="handleItem.fiscalQuantity" :min="1"/>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>处理说明</label>
                </div>
                <div class="form-value width-2x">
                    <el-form-item prop="fiscalComment">
                        <el-input v-model="handleItem.fiscalComment"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import assetVchrApi from '../../api/assetVchr';
    import shopStockApi from '../../api/shopStock'
    import{ openRetailComTreeSelectDlg } from './selectDlg'

    export default {
        name: 'swb-shop-device-stock-handle-item-save',
        desc: '机构资产盘点单保存',
        props: ['voucherItem', 'voucher', 'handleItemId', 'fiscalHandle', 'totalFiscalQuantity', 'batch'],
        data: function () {
            return {
                handleItem: {
                    wayValue: null,
                    fiscalWayValue: null,
                    quantity: 1,
                    fiscalQuantity: 1,
                    theOtherComId: null,
                    theOtherComLevel: null,
                    theOtherComName: null,
                    theOtherWarehouseId: null,
                    theOtherWarehouseName: null,
                    clearCause: null,
                    fiscalComment: null,
                },
                assetCheckHandleWayEnumList: [],
                devcClearCauseEnumList: [],
                checkResultSign: 0,
                transComFlag: false,
                // 资产所属仓库(盘点仓库),注意不能是同仓库
                warehouseList: [],
                dbQuantity: 0,
                dbFiscalQuantity: 0
            }
        },
        created: function () {
            if(!Utils.isNoB(this.handleItemId)) {
                // 修改
                this.getHandleItem(this.handleItemId);
            }
            this.init();
        },
        methods: {
            init(){
                let self = this;
                if(self.voucherItem.checkedDelta > 0) {
                    // 盘盈
                    self.checkResultSign = 1;
                } else if(self.voucherItem.checkedDelta < 0) {
                    // 盘亏
                    self.checkResultSign = -1;
                }
                // self.assetCheckHandleWayEnumMap = getEnumMap('assetCheckHandleWay', 'value2text');
                self.devcClearCauseEnumList = getEnumList("devcClearCause");
                let assetCheckHandleWayEnumList = [];
                if(Utils.isTrue(self.fiscalHandle)) {
                    let dbAssetCheckHandleWayEnumList = getEnumList("assetCheckFiscalHandleWay");
                    dbAssetCheckHandleWayEnumList.forEach(function (item) {
                        if(self.checkResultSign == 1) {
                            if(item.value == 1) {
                                assetCheckHandleWayEnumList.push(item);
                            }
                        } else {
                            if(item.value < 0) {
                                assetCheckHandleWayEnumList.push(item);
                            }
                        }
                    })
                } else {
                    let dbAssetCheckHandleWayEnumList = getEnumList("assetCheckHandleWay");
                    dbAssetCheckHandleWayEnumList.forEach(function (item) {
                        if(item.value != -5) {
                            if(self.checkResultSign == 1 && item.value > 0 && (self.voucherItem.durable || item.value != 4)) {
                                if(!self.voucherItem.lowCostFlag || (item.value != 2 && item.value != 4)) {
                                    assetCheckHandleWayEnumList.add(item);
                                }
                            } else if(self.checkResultSign == -1 && item.value < 0 && (self.voucherItem.durable || item.value != -4)) {
                                if(self.voucherItem.lowCostFlag) {
                                    if(item.value == -1 || item.value == -9 || item.value == -2) {
                                        assetCheckHandleWayEnumList.add(item);
                                    }
                                } else {
                                    assetCheckHandleWayEnumList.add(item);
                                }
                            }
                        }
                    });
                    if(!Utils.isNoB(self.voucherItem) && self.voucherItem.fiscalAcctFlag == 0) {
                        for(let i = 0; i < assetCheckHandleWayEnumList.length; i++) {
                            let assetCheckHandleWayEnum = assetCheckHandleWayEnumList[i];
                            if(assetCheckHandleWayEnum.value == -6) {
                                assetCheckHandleWayEnumList.splice(i, 1);
                                break;
                            }
                        }
                    }
                }
                self.assetCheckHandleWayEnumList = assetCheckHandleWayEnumList;
                self.getWarehouseList(self.voucher.retailerComId);
            },
            getHandleItem(id){
                let self = this;
                let msgBoxDlg = MsgBox.loading();
                assetVchrApi.getShopDeviceStockHandleItemsById(id, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let handleItem = result.data;
                        if(handleItem.theOtherComId != self.voucher.retailerComId) {
                            self.transComFlag = true;
                        }
                        self.handleItem = handleItem;
                        self.dbQuantity = handleItem.quantity;
                        self.dbFiscalQuantity = handleItem.fiscalQuantity;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showOrgSelectDlg(){
                let self = this;
                let handleItem = this.handleItem;
                let dlgConfig = {};
                dlgConfig.isRadio = true;
                dlgConfig.isShowIcons = false;
                dlgConfig.enableSearch = true;
                dlgConfig.title = '机构--选择';
                dlgConfig.deaprtFlag = true;
                dlgConfig.isCom = true;
                openRetailComTreeSelectDlg(dlgConfig, function (result) {
                    if(result.id == self.voucher.retailerComId) {
                        Toast.show("不能选择资产所属机构");
                        return true;
                    }
                    handleItem.theOtherComId = result.id;
                    handleItem.theOtherComLevel = result.level;
                    handleItem.theOtherComName = result.name;
                });
            },
            getWarehouseList(retailerShopId){
                let self = this;
                let postData = {
                    filterItems: {
                        retailerShopId: retailerShopId
                    }
                };
                let msgBoxDlg = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let warehouseList = result.data || [];
                        self.warehouseList = warehouseList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            compareIn(val) {
                if(this.voucher.warehouseId == val) {
                    this.handleItem.theOtherWarehouseId = null;
                    this.handleItem.theOtherWarehouseName = null;
                    Toast.show("不能选择资产所属的仓库");
                }
            },
            clearTheOtherInfo(){
                this.handleItem.theOtherComId = null;
                this.handleItem.theOtherComLevel = null;
                this.handleItem.theOtherComName = null;
                this.handleItem.theOtherWarehouseId = null;
                this.handleItem.theOtherWarehouseName = null;
            },
            checkNull(rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    callback();
                }
            },
            checkQuantity(rule, value, callback){
                let self = this;
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    let checkQuantity = self.voucherItem.allowQuantity + self.dbQuantity;
                    if(!Utils.isNaturalStr(value, true) || value > checkQuantity) {
                        callback(new Error('处理数量是大于0的整数并且不能超过未处理数量!'));
                    } else {
                        callback();
                    }
                }
            },
            checkFiscalQuantity(rule, value, callback){
                let self = this;
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空!'));
                } else {
                    let checkedDelta = self.voucherItem.checkedDelta;
                    if(checkedDelta < 0) {
                        checkedDelta = 0 - checkedDelta;
                    }
                    let checkQuantity = checkedDelta - self.totalFiscalQuantity + self.dbFiscalQuantity;
                    if(!Utils.isNaturalStr(value, true) || value > checkQuantity) {
                        callback(new Error('处理数量是大于0的整数并且不能超过' + checkQuantity));
                    } else {
                        callback();
                    }
                }
            },
            getDlgResult(){
                let self = this;
                // 本机构调拨
                if(!this.transComFlag) {
                    this.handleItem.theOtherComId = this.voucher.retailerComId;
                    this.handleItem.theOtherComLevel = this.voucher.retailerComLevel;
                    this.handleItem.theOtherComName = this.voucher.retailerComName;
                }
                let result = {};
                self.$refs['handleItemForm'].validate(function (valid) {
                    if(valid) {
                        let handleItem = self.handleItem;
                        let voucherItem = self.voucherItem;
                        handleItem.voucherItemId = voucherItem.id;
                        // 仓库名
                        if(!Utils.isNoB(handleItem.theOtherWarehouseId)) {
                            self.warehouseList.forEach(function (warehouse) {
                                if(warehouse.id == handleItem.theOtherWarehouseId) {
                                    handleItem.theOtherWarehouseName = warehouse.name;
                                }
                            });
                        } else {
                            handleItem.theOtherWarehouseName = null;
                        }
                        result.type = "info";
                        result.data = handleItem;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/retailer/ShopDeviceStockHandleItemSave.vue